import {
  Modal,
  CustomizedTypography,
  CustomizedButton
} from '@components/Customized';

interface OnProcessingWarningModalProps {
  open: boolean;
  onClose: () => void;
}

const OnProcessingWarningModal: React.FunctionComponent<OnProcessingWarningModalProps> = ({
  open,
  onClose
}) => {
  return (
    <Modal onClose={onClose} open={open}>
      <Modal.CloseButton onClose={onClose} />
      <Modal.Title>진행알림</Modal.Title>
      <Modal.ContentSection>
        <CustomizedTypography variant="h4">
          가장 최신 견적서로 제조를 진행중입니다. 결제취소 혹은 결제 대금 환불
          후 수정 요청을 보내주세요.
        </CustomizedTypography>
      </Modal.ContentSection>
      <Modal.ButtonSection>
        <CustomizedButton
          variant="contained"
          color="error"
          onClick={onClose}
          fullWidth
        >
          확인
        </CustomizedButton>
      </Modal.ButtonSection>
    </Modal>
  );
};

export default OnProcessingWarningModal;
